import {
  Flex,
  PasswordInput,
  Text,
  type FlexProps,
  type PasswordInputProps,
} from '@mantine/core';
import classes from './FormPasswordInput.module.scss';

interface FormPasswordInputProps extends PasswordInputProps {
  title: string;
  description: string;
  containerProps?: FlexProps;
}

export const FormPasswordInput = ({
  title,
  description,
  containerProps,
  ...props
}: FormPasswordInputProps) => {
  return (
    <Flex gap='24' className={classes.formRow} {...containerProps}>
      <Flex direction='column' gap={6} className={classes.leftColumn}>
        <Text className={classes.title}>{title}</Text>
        <Text className={classes.description}>{description}</Text>
      </Flex>

      <PasswordInput
        className={classes.rightColumn}
        type='password'
        radius='0.75rem'
        variant='filled'
        {...props}
      />
    </Flex>
  );
};
